import React from 'react'
import useAppContext from '../../hook/useAppContext'
import AsideBar from '../asidebar/AsideBar'
import Main from '../main/Main'
import Aside from '../aside/Aside'
import Friends from '../friends/Friends'
import Relation from '../relation/Relation'
import Modal from '../modal/Modal'

const Container = () => {

      const {user} = useAppContext()

      if(user.length === 0) return 

      return (
            <div className="container flex">
                  <AsideBar /> 
                  <Main /> 
                  <Aside />
                  <Friends />
                  <Relation />
                  <Modal />
            </div>
      )
}

export default Container
